
import React from "react";
import "./PrivacyPolicy.css";
export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p>Last updated: August 16, 2026</p>
        </div>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Vortex Network. We respect your privacy and are committed
            to protecting the personal information you provide when using our
            website, services, and related features.
          </p>
          <p>
            This Privacy Policy explains what information we may collect, how we
            use it, how we protect it, and what rights you have regarding your
            information.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>
            Depending on how you use Vortex Network, we may collect or process
            the following information:
          </p>

          <ul>
            <li>Username or display name</li>
            <li>Email address</li>
            <li>Account authentication information</li>
            <li>Profile information</li>
            <li>Website preferences and settings</li>
            <li>IP address and basic technical information</li>
            <li>Browser and device information</li>
            <li>Information you voluntarily submit through support forms</li>
            <li>Website activity and usage information</li>
          </ul>

          <p>
            We only collect information that is reasonably necessary to provide,
            maintain, secure, and improve our services.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>Information we collect may be used to:</p>

          <ul>
            <li>Create and manage your account</li>
            <li>Provide access to website features</li>
            <li>Provide downloads and services</li>
            <li>Respond to support requests</li>
            <li>Improve our website and services</li>
            <li>Maintain website security for unauthorized access</li>
            <li>Communicate important service updates</li>
            <li>Understand how users interact with our website</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies and Local Storage</h2>
          <p>
            Vortex Network may use cookies, local storage, or similar technologies
            to keep you signed in, remember your preferences, and improve your
            experience.
          </p>

          <p>
            Some cookies or storage technologies may be required for essential
            website functionality, such as authentication and security.
          </p>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>
            We use third-party services to operate parts of our
            website and these services have separate terms and conditions please read when you sign up.
          </p>

          <p>These services may include:</p>

          <ul>
            <li>Discord - For communication, bug reporting and additional support.</li>
            <li>Content distribution and download platforms - Curseforge, Mcpedl.</li>
          </ul>

          <p>
            Third-party services have their own privacy policies and terms and conditions. We
            recommend reviewing their policies when using features that connect
            to external services.
          </p>
        </section>

        <section>
          <h2>6. Discord and External Accounts</h2>
          <p>
            If you choose to connect your Vortex Network account to Discord or
            another external service, we may receive limited information from
            that service that is necessary to provide the requested integration.
          </p>

          <p>
            We do not receive your external account password through these
            integrations.
          </p>
        </section>

        <section>
          <h2>7. Data Security</h2>
          <p>
            We take reasonable measures to protect your information from
            unauthorized access, alteration, disclosure, or destruction.
          </p>

          <p>
            However, no online service can guarantee complete security. You
            should use a strong, unique password and avoid sharing your account
            credentials with other people.
          </p>
        </section>

        <section>
          <h2>8. Data Retention</h2>
          <p>
            We retain usernames and email information for communication purposes only and website traffic.
          </p>

          <p>
            When information is no longer required, we may delete or anonymize
            it where appropriate.
          </p>
        </section>

        <section>
          <h2>9. Your Rights</h2>
          <p>
            you have the right regarding your
            information, including the right to:
          </p>

          <ul>
            <li>Request access to personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of certain information</li>
          </ul>

          <p>
            If you would like to exercise one of these rights, please contact us
            using the contact information provided below.
          </p>
        </section>

        <section>
          <h2>10. Children's Privacy</h2>
          <p>
            Our services are not intended to knowingly collect personal
            information from children where such collection is prohibited by
            applicable law.
          </p>

          <p>
            If you believe that a child has provided us with personal information
            without appropriate consent, please contact us so that we can review
            and take appropriate action.
          </p>
        </section>

        <section>
          <h2>11. Data Deletion</h2>
          <p>
            If you would like your Vortex Network account or associated personal
            information deleted, you can contact us with your request.
          </p>

          <p>
            Some information may be needed to be retained where required by law.
          </p>
        </section>

        <section>
          <h2>12. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes to our services, technology, or legal requirements.
          </p>

          <p>
            When changes are made, we will update the "Last updated" date at the
            top of this page. We recommend checking this page periodically.
          </p>
        </section>

        <section>
          <h2>13. Contact Us</h2>
          <p>
            If you have questions, concerns, or requests please contact the Vortex Network team on details listed below or through our discord <a href="https://discord.com/invite/D8Z4HyRT6t">https://discord.com/invite/D8Z4HyRT6t</a> or email address.
          </p>

          <div className="privacy-contact">
            <p>
              <strong>Vortex Network</strong>
            </p>
            <p>
              Email: <a href="mailto:support@vortexnetowrknew.co.uk">
                support@vortexnetowrknew.co.uk
              </a>
            </p>
          </div>
        </section>

        <div className="privacy-footer">
          <p>
            © {new Date().getFullYear()} Vortex Network. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

